module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slip"
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "selector-pick-container",
    style: ({
      height: '100%',
      top: _vm.top,
      left: _vm.left,
      position: _vm.position
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./src/components/emapm-form/baseComponents/bsTransitionPage.vue